import React from "react"
import {FieldViewSize} from "../../../../../const"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";
import FieldProjectType_Editable from "../editable/editable";

const debug = false
// const debug = "FieldProjectType_Editable"

export default function FieldProjectType_TableCell(props:FieldTableCellProps) {

    const onChange = (value:any) => {
        props.field.fieldParams.tableCellOnValueChange!(props.listItem, value, props.manager)
    }

    return (
        <div className="cell-flex p-h-0" style={getTableCellStyle(props)}>
            <FieldProjectType_Editable size={FieldViewSize.SMALL}
                                       iconOnly={props.column.width!<80}
                                       className="w-100-percent h-100-percent"
                                       disabled={props.manager.isReadOnly}
                                       field={props.field}
                                       model={props.listItem.project}
                                       onChange={onChange}/>
        </div>
    )
}
